const awsconfig = {
    aws_project_region: 'eu-west-1',
    aws_cognito_identity_pool_id: 'eu-west-1:3577a0cd-9a89-48be-86c1-b7fe8a9d8a36',
    aws_cognito_region: 'eu-west-1',
    aws_user_pools_id: 'eu-west-1_CPYIMwbLB',
    aws_user_pools_web_client_id: '172en1fqcmvmkme4bflkqinefv',
    aws_user_files_s3_bucket: 'mos-mg-sync-apac1',
    aws_user_files_s3_bucket_region: 'ap-southeast-1',
    aws_content_delivery_bucket: 'mos-mg-sync-apac1',
    aws_content_delivery_bucket_region: 'ap-southeast-1',
    aws_appsync_graphqlEndpoint: 'https://b4wz4zyjqzaprijgajuk66sbkq.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};

const awsconfig2 = {
    aws_project_region: 'eu-central-1',
    aws_cognito_identity_pool_id: 'eu-central-1:46a99fde-033a-4a72-86a1-7a42cfbeba52',
    aws_cognito_region: 'eu-central-1',
    aws_user_pools_id: 'eu-central-1_GX84pIupw',
    aws_user_pools_web_client_id: '2pah7n8192e7qegf3cubmkctro',
    aws_user_files_s3_bucket: 'mos-mg-sync-apac1a',
    aws_user_files_s3_bucket_region: 'ap-southeast-1a',
    aws_content_delivery_bucket: 'mos-mg-sync-apac1a',
    aws_content_delivery_bucket_region: 'ap-southeast-1a',
    aws_appsync_graphqlEndpoint: 'https://b4wz4zyjqzaprijgajuk66sbkq.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};
// telstra USE
const awsconfig3 = {
    aws_project_region: 'eu-west-1',
    aws_cognito_identity_pool_id: 'eu-west-1:c712746f-650b-4b80-9316-22da5eb8a2fe',
    aws_cognito_region: 'eu-west-1',
    aws_user_pools_id: 'eu-west-1_DZEotqEXJ',
    aws_user_pools_web_client_id: '2ta8n9v5u0ed564o7c90on65ed',
    aws_user_files_s3_bucket: 'mos-mg-sync-apac1',
    aws_user_files_s3_bucket_region: 'ap-southeast-1',
    aws_content_delivery_bucket: 'mos-mg-sync-apac1',
    aws_content_delivery_bucket_region: 'ap-southeast-1',
    aws_appsync_graphqlEndpoint: 'https://b4wz4zyjqzaprijgajuk66sbkq.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
};
	
// telstradev UPD
const awsconfig4 = {
    aws_project_region: 'eu-central-1',
    aws_appsync_graphqlEndpoint: 'https://v7fa44ze5jgkfoo5wqu6n4fxua.appsync-api.eu-central-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-central-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_appsync_apiKey: 'da2-zh7omwft3vfmfcvb3rt4uxz3ge',
    aws_cognito_identity_pool_id: 'eu-central-1:a95d202a-b591-4ee7-87dd-b071f0d43aaa',
    aws_cognito_region: 'eu-central-1',
    aws_user_pools_id: 'eu-central-1_UJY1MypIt',
    aws_user_pools_web_client_id: '7n6o226jke5eek7fisj4s2fv1n',
    oauth: {},
  };


export default awsconfig3;
